import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_COLOR_REPLACE from './Fragment/color_replace.frag';

export default class ColorReplaceShader extends Shader {
	public u_threshold:Uniform.Uniform1f = new Uniform.Uniform1f(0.05882352941176470588235294117647);

	public u_color:Uniform.Uniform4fv = new Uniform.Uniform4fv(
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0]
	);
	public u_color_replacement:Uniform.Uniform4fv = new Uniform.Uniform4fv(
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0],
		[0.0, 0.0, 0.0, 0.0]
	);

	public frag = ():string => FRAG_COLOR_REPLACE;
}